// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5597) return "static/chunks/5597-be9687efc5929563.js";
	if (chunkId === 3566) return "static/chunks/3566-73def975fe393e85.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2279":"8685d0e0aeba3f5a","9405":"c59f8c92fd85168b"}[chunkId] + ".js";
};